var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-transaction",class:{ 'disabled': _vm.isDisabled, 'has-icon': _vm.data.icon },on:{"click":_vm.open}},[_c('div',{staticClass:"icon-container"},[_c('i',{class:_vm.data.icon})]),_c('p',[_vm._v(_vm._s(_vm.data.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }